<template>
  <div id="app">
    <el-container>
      <el-header>
		<div class="header-box animated" :class="{fixed:isFixed,fadeInDown:isFixed}">
		<div class="header-content">
			<div class="logo">
			 <a href="/"><img src="./assets/img/toplogo.png" alt /></a>
			</div>
			<el-menu
			  :default-active="defaultActive"
			  class="el-menu-demo"
			  mode="horizontal"
			  :router="router"
			>
			  <el-menu-item index="/">首页</el-menu-item>
			  <el-menu-item index="/goin">公司简介</el-menu-item>
			  <!-- <el-menu-item index="/product">解决方案</el-menu-item> -->
			  <el-submenu index="2">
				  <template slot="title">解决方案</template>
				  <el-submenu index="2-1">
					<template slot="title">结构物健康监测</template>
					<el-menu-item :route="{name:'product',params: { id:'d908d3c2-3ea5-4b57-8a68-f108a5c12472',name:'桥梁'}}" index="2-1-1">桥梁</el-menu-item>
					<el-menu-item :route="{name:'product',params: { id:'861460c1-28bf-4215-a52e-93ccfc282fc3',name:'隧道'}}" index="2-1-2">隧道</el-menu-item>
					<el-menu-item :route="{name:'product',params: { id:'f8bc825b-7775-4bd1-9aac-3125355e26c2',name:'边坡'}}" index="2-1-3">边坡</el-menu-item>
					<el-menu-item :route="{name:'product',params: { id:'ddc9fb8c-cd8c-4aa9-8f0b-eeee9c7bd2fa',name:'水利大坝'}}" index="2-1-4">水利大坝</el-menu-item>
					<el-menu-item :route="{name:'product',params: { id:'40353b92-f97e-4fcb-8fbf-45c74b879731',name:'基坑'}}" index="2-1-5">基坑</el-menu-item>
					<el-menu-item :route="{name:'product',params: { id:'d7246e15-44d1-4202-8255-e792d2f34aa3',name:'港口码头'}}" index="2-1-6">港口码头</el-menu-item>
					<el-menu-item :route="{name:'product',params: { id:'4cd03ef4-00fa-4925-816f-928892c5b820',name:'健康监测'}}" index="2-1-7">健康监测</el-menu-item>
				  </el-submenu>
				  <el-submenu index="3-1">
					<template slot="title">智慧工地SAAS平台</template>
					<el-menu-item :route="{name:'saas',params: { id:'c26fab28-881a-4e2a-835b-ab2c5fc01471',name:'项目管理'}}" index="3-1-1">项目管理</el-menu-item>
					<el-menu-item :route="{name:'saas',params: { id:'e17987c9-8678-4858-8fd1-88ac5d3aaf83',name:'智慧工地'}}" index="3-1-2">智慧工地</el-menu-item>
					<el-menu-item :route="{name:'saas',params: { id:'4fbcce7e-4fe1-4b19-8158-46567a9effe3',name:'AI智能分析'}}" index="3-1-3">AI智能分析</el-menu-item>
					<el-menu-item :route="{name:'saas',params: { id:'0947db54-f664-4f45-8dcd-9a57b5675197',name:'特种设备'}}" index="3-1-4">特种设备</el-menu-item>
					<el-menu-item :route="{name:'saas',params: { id:'e3dabe78-a784-4545-935a-92a1404cef4a',name:'智慧隧道'}}" index="3-1-5">智慧隧道</el-menu-item>
					<el-menu-item :route="{name:'saas',params: { id:'be5feaf4-83b7-4246-a316-b6d04546c070',name:'VR运用'}}" index="3-1-6">VR运用</el-menu-item>
					<el-menu-item :route="{name:'saas',params: { id:'e4ed4b04-7db0-447e-8b74-cd0ca59a695f',name:'监理云'}}" index="3-1-7">监理云</el-menu-item>
				  </el-submenu>
				  <!-- <el-menu-item index="">智慧工地</el-menu-item> -->
				  <!-- <el-menu-item index="">智慧交通</el-menu-item> -->
				  <el-submenu index="4-1">
					<template slot="title">智慧交通</template>
					<el-menu-item :route="{name:'traffic',params: { id:'58e39bb2-8d1c-4e2c-8477-89986f74cf50',name:'智慧治超'}}" index="4-1-1">智慧治超</el-menu-item>
					<el-menu-item :route="{name:'traffic',params: { id:'63779d4a-3588-4955-8855-d692fb65ef96',name:'科技示范路'}}" index="4-1-2">科技示范路</el-menu-item>
				  </el-submenu>
			  </el-submenu>
			  <!-- <el-menu-item index="/case">经典案例</el-menu-item> -->
			  <el-submenu index="3">
				  <template slot="title">经典案例</template>
				  <el-menu-item index="/case">结构物健康监测</el-menu-item>
				  <el-menu-item index="/case02">智慧工地</el-menu-item>
				  <el-menu-item index="/case01">智慧交通</el-menu-item>
				  <el-menu-item :route="{name:'newsdetails',params: { id:'71f9c4ac-2854-497a-81ee-5136ea872e86'}}" index="3-2">业绩一览表</el-menu-item>
			  </el-submenu>
			  <el-menu-item index="/center">产品中心</el-menu-item>
			  <el-menu-item index="/news">新闻资讯</el-menu-item>
			  <el-menu-item index="/contactus">联系我们</el-menu-item>
			  <!-- <el-menu-item index="/download">下载APP</el-menu-item> -->
			</el-menu>
			<div style="line-height: 60px;font-size: 15px;color: #fd5353;">
				电话:0791-86613192 &nbsp;&nbsp; 传真:0791-83801732
			</div>
		</div>
		</div>
      </el-header>
      <!-- <el-main> -->
		<keep-alive>
		    <router-view v-if="$route.meta.keepAlive">
		        <!-- 这里是会被缓存的视图组件 -->
		    </router-view>
		</keep-alive>
		
		<router-view v-if="!$route.meta.keepAlive">
		    <!-- 这里是不被缓存的视图组件 -->
		</router-view>
      <!-- </el-main> -->
      <div class="footer">
        <div class="footer-content">
          <ul class="content-nav">
			<li  v-for="(item,index) in newstypeList" :key="index">
			    <p>{{item.menuName}}</p>
			   <div
			   	 v-for="(type, index2) in item.menuData"
				 :key="type.id"
			     @click="newstypeChange(type, item.pathType)"
				 :class="{'active':type.id == newstype}"
			   >
			     <span class="hover-effect" style=" cursor: pointer;">{{type.name}}</span>
			   </div>
			</li>
			<li>
				<p>公司简介</p>
				<router-link :to="{ name: 'goin'}"><span>关于我们</span></router-link>
				<router-link :to="{ name: 'goin'}"><span>发展历程</span></router-link>
				<router-link :to="{ name: 'goin'}"><span>资质荣誉</span></router-link>
				<router-link :to="{ name: 'goin'}"><span>企业文化</span></router-link>
				<router-link :to="{ name: 'goin'}"><span>公司掠影</span></router-link>
			</li>
            <li>
              <p>联系我们</p>
              <span>邮箱：jxth@jxth.com</span>
              <span>电话：0791-86613192</span>
			  <span>传真：0791-83801732</span>
              <span>地址：江西省南昌经济技术开发区 瑞香路900号通慧科技大厦</span>
            </li>
          </ul>
		  <div>
			  <img src="./assets/img/ercode.jpg" alt />
			  <span>扫码关注官方微信公众号</span>
		  </div>
        </div>
        <div class="copyright">
			<a href="https://xyt.xcc.cn/getpcInfo?sn=1763172707236532224&language=CN&certType=8&url=www.jxth.com.cn" target="_blank" style="position: relative;display: inline-block;height: 38px;vertical-align: middle;margin-right: 15px;">
				<div style="width:100%;height:100%;text-align: center;">
					<embed src="https://program.xinchacha.com/web/1763172707236532224=www.jxth.com.cn.svg"width="103" height="38" type="image/svg+xml" pluginspage="//www.adobe.com/svg/viewer/install/"/>
				</div>
			</a>
			<span>Copyright @ 2012-2025 江西通慧科技集团股份有限公司--<a  href="http://beian.miit.gov.cn" target="view_window">赣ICP备17002352号-1</a></span>
        </div>
		
      </div>
    </el-container>
	<div id="goTop">
	    <div class="goTop" v-show="goTopShow" @click="goTop">
	        <i class="el-icon-caret-top goTopIcon"></i>
	    </div>
	</div>
  </div>
</template>
<script>
import merge from 'webpack-merge'
export default {
  data() {
    return {
      router: true,
      defaultActive: "/",
	  scrollTop: "",
	  goTopShow: false,
	  isFixed: false,
	  newstypeList: [],
	  newstype: '',
    };
  },
  watch:{
	$route(to,from){
		if(to.path.indexOf('product') !== -1){
			this.defaultActive = '2-1-1'
		}else if(to.path.indexOf('saas') !== -1){
			this.defaultActive = '3-1-1'
		}else if(to.path.indexOf('traffic') !== -1){
			this.defaultActive = '4-1-1'
		}else{
			this.defaultActive = to.path
		}
		document.body.scrollTop = document.documentElement.scrollTop = 0
		if(to.path.indexOf('mb') !== -1){
			this.$router.push({path:'/'})
		}
	},
	scrollTop(val) {
	    if (this.scrollTop > 500) {
	        this.goTopShow = true;
	    } else {
	        this.goTopShow = false;
	    }
	}
  },
  methods: {
	  async getAllList(){
		this.newstypeList = [
			{
				menuName: '新闻资讯',
				pathType:'query',
				menuData: [
					{ name:'企业新闻', id:'064dfdd0-8a17-4421-8e79-ff253eed4ebb', toPathName: 'news' },
					{ name:'公司公告', id:'57b600fc-caae-4d5e-94d0-9146cca5a3f9', toPathName: 'news' },
					{ name:'项目动态', id:'5e7c8bbb-4881-4dfd-8efd-0344d1f4e3c0', toPathName: 'news' },
					{ name:'员工笔记', id:'ddbc7f4d-8d89-4f85-809f-5b4fe4ff8746', toPathName: 'news' },
				],
			},
			{
				menuName: '解决方案',
				pathType:'params',
				menuData: [
					{ name:'结构物健康监测', id:'d908d3c2-3ea5-4b57-8a68-f108a5c12472', toPathName: 'product', metaName: '桥梁' },
					{ name:'智慧工地SAAS平台', id:'c26fab28-881a-4e2a-835b-ab2c5fc01471', toPathName: 'saas', metaName:'项目管理' },
					{ name:'智慧交通', id:'58e39bb2-8d1c-4e2c-8477-89986f74cf50', toPathName: 'traffic', metaName:'智慧治超'}
				]
			}
		]
	  },
	  newstypeChange(type, pathType){
		  this.newstype = type.id
		  const currentPath = this.$route.fullPath
		  if(pathType === 'query') {
			  const pathName = type.toPathName
			  const toPath = `/${pathName}?id=${this.newstype}`
			  if(toPath !== currentPath) {
			  	this.$router.push({
					name: pathName,
					query:{
					  id:type.id
					}
			  	})	  
			  }
		  } else {
			  const toPath = `/${type.toPathName}/${type.id}/${type.metaName}`
			  if(encodeURI(toPath) === currentPath) return
			  this.$router.push({
				 name: type.toPathName,
				 params:{
				  id:type.id,
				  name: type.metaName
				 }
			  })
		  }
	  },
	getListByPage(){
		var curPage = this.pageInfo.curPage
		var pageSize = this.pageInfo.pageSize
		var category = this.newstype
		// console.log(this.$qs.stringify({curPage,pageSize,category}))
		this.$http.post('/oa/newcms/article/getListByPage',{curPage,pageSize,category})
		.then(response => {
			this.newsList = response.data.result.data
			this.pageInfo.total = Number(response.data.result.total)
			// console.log(response)
			// console.log(this.newsList)
		})
		.catch(error=> {
		  
		})
	},
	  handleScroll() {
	      this.scrollTop =
	          window.pageYOffset ||
	          document.documentElement.scrollTop ||
	          document.body.scrollTop;
	      if (this.scrollTop > 500) {
	          this.goTopShow = true;
	      }
		  if(this.scrollTop > 60){
			  this.isFixed = true
		  }
		  if(this.scrollTop === 0){
			  this.isFixed = false
		  }
	  },
	  goTop() {
	      let timer = null,
	          _that = this;
	      cancelAnimationFrame(timer);
	      timer = requestAnimationFrame(function fn() {
	          if (_that.scrollTop > 0) {
	              _that.scrollTop -= 50;
	              document.body.scrollTop = document.documentElement.scrollTop =
	                  _that.scrollTop;
	              timer = requestAnimationFrame(fn);
	          } else {
	              cancelAnimationFrame(timer);
	              _that.goTopShow = false;
	          }
	      });
	  }
  },
  mounted() {
      window.addEventListener("scroll", this.handleScroll);
	  this.getAllList()
	  
  },
  destroyed() {
      window.removeEventListener("scroll", this.handleScroll);
  }
};
</script>
<style lang="scss">
@import './assets/css/vue2-editor.css';
@import './assets/css/animate.min.css';
.goTop {
    position: fixed;
    right: 40px;
    bottom: 60px;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: #fff;
	text-align: center;
	line-height: 40px;
    cursor: pointer;
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.12);
}
.goTop:hover .goTopIcon {
    color: rgba(51, 153, 255, 1);
}
.goTopIcon {
    font-size: 20px;
    color: rgba(51, 153, 255, 0.8);
}
.BMap_cpyCtrl {
  display: none;
}
.anchorBL {
  display: none;
}
* {
  padding: 0;
  margin: 0;
}
html,
body {
  height: 100%;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.el-header {
	width: 100%;
	background-color: #FFFFFF;
	.header-box{
		width: 100%;
		background-color: #FFFFFF;
		.header-content{
			display: flex;
			justify-content: space-between;
			align-content: center;
			width: 1400px;
			margin: 0 auto;
			.logo {
				width: 300px;
				padding-top: 5px;
				img {
				  width: 100%;
				  line-height: 60px;
				}
			}
			.el-menu.el-menu--horizontal{
				border-bottom: none;
			}
		}
		&.fixed{
			position: fixed;
			left: 0px;
			top: 0px;
			z-index: 9;
			border-bottom: 1px solid #DDDDDD;
			animate-delay: 0s; //动画延迟时间
			-webkit-animation-delay: 0s;
			animate-duration: 0.5s;   /* //动画持续时间 */
			-webkit-animation-duration: 0.5s;
		}
	}
}
.el-main {
  padding: 0 !important;
}

.footer {
  width: 100%;
  overflow: hidden;
  background-color: #030f27;
  padding: 40px 0 5px 0;
  &-content {
    width: 1200px;
    margin: 0 auto;   
    display: flex;
    justify-content: space-between;
    .content-nav {
      display: flex;
      justify-content: space-around;
      li {
        display: flex;
        flex-direction: column;
        padding: 0 20px;
        //justify-content: center;
        align-items: flex-start;
		.hover-effect{
			&:hover{				
				color:#fff;					
			}	
		}
		a{
			text-decoration: none;
			&:hover{
				span{
					color:#fff;
					}
			}		
			
		}	
        p {
          font-size: 20px;
          color: #fff;
          padding: 10px 0;
        }
        span {
          color: #ddd;
          font-weight: 300;
          padding: 5px 0;
		 
        }
      }
    }
    img {
		display: block;
		width: 150px;
		height: 150px;
		border-radius: 5px;
    }
	span{
		display: block;
		text-align: center;
		color: #FFFFFF;
		font-size: 14px;
		margin-top: 10px;
	}
  }
  .copyright {
	margin-top: 10px;
    height: 50px;
    background: #030f27;
	text-align: center;
	
    span {
		vertical-align: middle;
		font-size: 14px;
		color: #999ea6;
		line-height: 30px;
		a{
			color: #999ea6;
		}
    }
  }
}
</style>
